module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('stepTitle', {
    attrs: {
      "navItems": ['Live Culture'],
      "index": 1,
      "step": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "cloud row mx-auto align-items-center py-5 "
  }, [_c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between px-5"
  }, [_c('div'), _vm._v(" "), _c('h5', {
    staticClass: "m-auto"
  }, [_vm._v(_vm._s(_vm.$t('select_unit')))]), _vm._v(" "), _c('img', {
    staticClass: "back-icon pointer my-4",
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "src": require("../../../assets/image/icon/close_lesson.png")
    },
    on: {
      "click": _vm.previousPage
    }
  })])]), _vm._v(" "), _vm._l((_vm.countrys), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-3 col-sm-6"
    }, [_c('div', {
      staticClass: "unit-box",
      on: {
        "click": function($event) {
          return _vm.goUnit(item.id)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.pic
      }
    }), _vm._v(" "), _c('h5', [(_vm.$i18n.locale === 'tw') ? _c('span', [_vm._v("\n              " + _vm._s(item.name) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n              " + _vm._s(item.englishName) + "\n            ")])])])])
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1cf735a5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/ar/Options.vue
// module id = 757
// module chunks = 3